export default "__VITE_ASSET__DYHrIlWN__"